import { useEffect, useState } from 'react';
import { GridApi } from '@ag-grid-community/core';

export function useGridSearch<TItem = unknown>({ data, gridApi }: { data: TItem[]; gridApi?: GridApi | null }) {
    const [displayedTotal, setDisplayedTotal] = useState(0);
    const [quickFilterText, setFilterText] = useState('');
    const onFilterTextChange = (value: string) => setFilterText(value);
    const onFilterChanged = () => {
        if (!gridApi) return;
        setDisplayedTotal(gridApi.getDisplayedRowCount());
    };

    useEffect(() => {
        setDisplayedTotal(data.length);
    }, [data]);

    return {
        displayedTotal,
        quickFilterText,
        onFilterTextChange,
        onFilterChanged,
    };
}
